<template>
    <div class="panel-body">
        <div class="panel-nav">

        </div>

        <div class="scroller padded">

        <h2 class="panel-header">Seleziona un carburante</h2>

        <ul id="fuels-list" class="scroller">
            <li v-for="_fuel in fuels"
                @click="fuel=_fuel">
                <span class="fuel-label">{{ _fuel.name }}</span>
            </li>
        </ul>

        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Fuels from "../models/fuels";

    export default {
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            loadData() {

                var $scope = this;

                $scope.fuels = Fuels.getList();
            }
        },
        data() {
            return {
              fuel: null,
                fuels: []
            };
        },
        created() {
            serverBus.$on('areaChanged',this.loadData);
            serverBus.$emit('pageChanged',{page:'FuelList'});
            this.loadData();
        },
        watch: {
            fuel: function (val) {
              serverBus.$emit("closePanel");
              serverBus.$emit("fuelChanged", val.id);
            }
        }
    }

</script>

<style lang="scss">
  #ecomotoriMap {
    #fuels-list {
        margin: 0px;
        padding-left: 10px;
        list-style: none;
        text-align: left;
        li {
            height: 40px;
            margin: 10px;
            padding: 10px;
            cursor: pointer;
            &:hover {
                background-color: #f3f3f3;
            }
        }
        span {
            height: 40px;
            display: inline-block;
            line-height: 40px;
            vertical-align: top;
        }
        .fuel-label {
            font-size: 20px;
            text-transform: uppercase;
            font-weight: bold;
            margin-left: 20px;
            width: calc(100%);
        }
    }
    }

    @media only screen and (max-width: 620px) {
      #ecomotoriMap {
        #countries-list {
              li {
                  zoom: 0.9;
              }
          }
        }
    }

    @media only screen and (max-width: 360px) {
    #ecomotoriMap {
      #countries-list {
            li {
                zoom: 0.70;
            }
        }
        }
    }

</style>
